import TabMenuList from './TabMenuList';
import useTabMenu from 'e3-common/hooks/useTabMenu';
import { useBoundStore } from 'e3-common/store/useBoundStore';

import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const TabContainer = () => {
    const { addTabMenu, closeAllTab } = useTabMenu();

    const userId = useBoundStore((state) => state.user.userId);
    const menuList = useBoundStore((state) => state.menu.menuList);

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (location?.pathname) {
            const m = menuList.find(
                (m) => import.meta.env.VITE_PUBLIC_URL + m.programRoutePath === location.pathname
            );
            if (m) {
                addTabMenu(m);
            } else {
                // 메인메뉴(홈버튼 클릭 등) 이동 시, 다른 탭이 닫혀서 주석
                // 버그 존재 시, 추가 작업 필요
                // closeAllTab();
            }
        }
    }, [location, menuList]);

    useEffect(() => {
        // 로그인이 안되어 있으면 모든 화면 닫기
        if (!userId) {
            closeAllTab();
            navigate(import.meta.env.VITE_PUBLIC_URL + '/login', { replace: true });
        }
    }, [userId]);

    return <TabMenuList />;
};

export default TabContainer;
